import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'bn-care-plan-item-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './care-plan-item-card.component.html',
  styleUrl: './care-plan-item-card.component.scss',
})
export class CarePlanItemCardComponent {}
